import { days } from 'config/Vars'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'

export function useCurrentAccessWeekdays() {
  const { access } = useCurrentSession()
  const firstDayOfWeek = firstDayOfWeekAsIndex(access.firstDayOfWeek)

  return days().slice(firstDayOfWeek, days().length).concat(days().slice(0, firstDayOfWeek))
}
